export default __webpack_public_path__ + "static/media/logo138x75black.5e94f064.png";